import { MdAlternateEmail } from 'react-icons/md';
import { BsGithub, BsLinkedin } from 'react-icons/bs';
import ContactForm from './ContactForm';

const contactMethods = [
  {
    icon: <MdAlternateEmail size={22} />,
    label: 'Email',
    value: 'santiago.ornsan@gmail.com',
    href: 'mailto:santiago.ornsan@gmail.com',
  },
  {
    icon: <BsLinkedin size={22} />,
    label: 'LinkedIn',
    value: '/in/santiago-ornelas',
    href: 'https://www.linkedin.com/in/santiago-ornelas/',
  },
  {
    icon: <BsGithub size={22} />,
    label: 'GitHub',
    value: '@Santi-Ornelas',
    href: 'https://www.github.com/Santi-Ornelas',
  },
];

const opportunities = [
  {
    emoji: '🤝',
    title: 'Collaboration',
    description: 'Open to partnering on meaningful projects that solve real problems and create real value.',
  },
  {
    emoji: '📚',
    title: 'Mentorship & Learning',
    description: 'Always looking to connect with experienced engineers and founders. Always learning, always growing.',
  },
];

const ContactSection = () => {
  return (
    <section id="contact" className="w-full" data-aos="fade-up">

      {/* Section Header */}
      <div className="text-center mb-12">
        <h2 className="section-heading">Let's Connect 👋</h2>
        <p className="dark:text-slate-400 text-slate-600 text-sm mt-3 max-w-xl mx-auto">
          Whether you have a project in mind, an opportunity to share, or just want to say hello —
          I'm always open to a conversation.
        </p>
      </div>

      {/* Contact Method Cards */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
        {contactMethods.map(method => (
          <a
            key={method.label}
            href={method.href}
            target="_blank"
            rel="noopener noreferrer"
            className="group p-5 rounded-2xl dark:border border dark:border-slate-700/50 border-slate-200
              dark:bg-[#0e0c29] bg-white text-center
              dark:hover:border-blue-500/30 hover:border-blue-400/30
              dark:hover:shadow-lg hover:shadow-lg
              dark:hover:shadow-blue-500/10 hover:shadow-blue-100/50
              hover:-translate-y-1 transition-all duration-300"
          >
            <div className="text-2xl dark:text-slate-400 text-slate-500
              dark:group-hover:text-blue-400 group-hover:text-blue-500
              mb-3 flex justify-center transition-colors duration-200">
              {method.icon}
            </div>
            <p className="text-sm font-semibold dark:text-white text-slate-900">{method.label}</p>
            <p className="text-xs dark:text-slate-500 text-slate-400 mt-1 truncate">{method.value}</p>
          </a>
        ))}
      </div>

      {/* Message Form + Tagline */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16 items-start">
        <div>
          <h3 className="text-xl font-bold dark:text-white text-slate-900 mb-6">Send a Message</h3>
          <ContactForm />
        </div>

        <div className="flex flex-col gap-6 lg:pt-14">
          <div className="p-6 rounded-2xl bg-gradient-to-br from-blue-500/10 to-purple-600/10
            dark:border border dark:border-blue-500/20 border-blue-300/30">
            <p className="text-2xl mb-3">⚡</p>
            <h4 className="font-bold dark:text-white text-slate-900 mb-2">Quick Response</h4>
            <p className="text-sm dark:text-slate-400 text-slate-600 leading-relaxed">
              I typically respond within 24 hours. Based in Mexico City (CST).
              Best way to reach me is by email or LinkedIn.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-gradient-to-br from-purple-500/10 to-blue-600/10
            dark:border border dark:border-purple-500/20 border-purple-300/30">
            <p className="text-2xl mb-3">🌎</p>
            <h4 className="font-bold dark:text-white text-slate-900 mb-2">Remote-First</h4>
            <p className="text-sm dark:text-slate-400 text-slate-600 leading-relaxed">
              Open to remote opportunities worldwide. Available for calls in CST, EST, and PST time zones.
            </p>
          </div>
        </div>
      </div>

      {/* Open to Opportunities */}
      <div className="border-t dark:border-slate-700/50 border-slate-200 pt-12">
        <div className="text-center mb-8">
          <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">
            Open to Opportunities
          </h3>
          <p className="dark:text-slate-400 text-slate-600 text-sm mt-2">
            Here's how we can work together
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {opportunities.map(card => (
            <div
              key={card.title}
              className="p-6 rounded-2xl dark:border border dark:border-slate-700/50 border-slate-200
                bg-gradient-to-br from-blue-500/5 to-purple-600/5
                dark:hover:border-blue-500/30 hover:border-blue-400/30
                hover:-translate-y-1
                dark:hover:shadow-lg hover:shadow-lg
                dark:hover:shadow-blue-500/10 hover:shadow-blue-100/40
                transition-all duration-300 text-center"
              data-aos="fade-up"
              data-aos-delay={opportunities.indexOf(card) * 100}
            >
              <span className="text-4xl mb-4 block">{card.emoji}</span>
              <h4 className="font-bold dark:text-white text-slate-900 mb-2">{card.title}</h4>
              <p className="text-sm dark:text-slate-400 text-slate-600 leading-relaxed">{card.description}</p>
            </div>
          ))}
        </div>
      </div>

    </section>
  );
};

export default ContactSection;
